<template>
  <div class="wall-surface-area__table-wrap">
    <!-- header-row -->
    <!-- <div class="surface-area__table-header-row">
      <div class="table-headers">ORIENTATION</div>
      <div class="table-headers">WWR orientation-wise (Glass + Frame)		
</div>
      <div class="table-headers">Opening Area(sq M)</div>
    </div> -->
    <!-- data-rows -->
    <div class="window-openable-rows-3B light-scrollbar">
      <div v-for="(window, i) in schema.inputs.step3B.windowTypeArrObj" :key="i" class="window-openable-columns-3B">
        <div style="text-align:center">{{ window.window_serial }}</div>
        <hr />
        <div class="window-openable__type">{{ window.window_type.openablePercent }} %</div>
        <hr />
        <template v-for="(orientationObj, k) in window.orientationObj">
          <div v-if="orientationObj.calcOpenableArea" class="step3B-window-openable-data-col">
            <div class="step3B__window-openable-orientation">
              <span class="orientation">{{ orientationObj.orientation }}</span>
            </div>
            <span class="orientation-percentage">{{ orientationObj.calcOpenableArea }}</span>
            <v-checkbox v-model="orientationObj.checkedOpenableArea"></v-checkbox>
          </div>
        </template>
      </div>
    </div>
    <hr />
    <v-alert dense text border="left" color="teal" icon="mdi-alert-circle">
      *Note: Tick the openable area of all windows opening directly to the external air, an open balcony, ‘verandah’, corridor or shaft.
    </v-alert>
    <hr />
    <div class="step-3B__summary">
      <div class="summary-head">Summary:</div>
      <div class="summary-block__wrap">
        <div class="summary-field__row" v-for="(window, k) in step3B.windowTypeArrObj" :key="k">
          <div class="sumarry-field__label">{{ window.window_serial }} Total openable area:<span class="units">(sq.M)</span></div>
          <div class="summary-field__value">{{ window.all_orient_openable_area }}</div>
          <!-- <div class="summary-field__value">0</div> -->
        </div>

        <hr />
        <div class="summary-field__row">
          <div class="sumarry-field__label">Overall openable area of all window:<span class="units">(sq.M)</span></div>
          <div class="summary-field__value">{{ step3B.summary_window_openable.total_openable_area }}</div>
          <!-- <div class="summary-field__value">0</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
import LvDropdown from 'lightvue/dropdown';
export default {
  components: {
    LvInput,
    LvDropdown,
  },
  data() {
    return {};
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
    calcAllOrientOpenableArea() {},
  },

  methods: {},
};
</script>

<style lang="scss">
.surface-area__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  margin-top: 12px;
  .table-headers {
    color: #343f4b;
    padding: 12px;
    font-size: 16px;
    width: 33.33%;
  }
}

.window-openable-rows-3B {
  padding: 12px 4px 4px 4px;
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: auto;
  overflow-x: auto;
  overflow-y: hidden;
  justify-content: space-around;
  .window-openable-columns-3B {
    display: flex;
    flex-direction: column;
    align-self: unset;
    margin: 0 4px 0 4px;
    //  width: 20%;
    .window-openable__type {
      height: 42px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}
.step3B-window-openable-data-col {
  display: flex;
  .orientation-percentage {
    background-color: #dedede;
    margin: 4px 0px;
    padding: 6px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.step3B__window-openable-orientation {
  width: 84%;
  margin: 4px 0px;
  background-color: #dedede;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  display: flex;
  .orientation {
    padding: 6px;
    color: #fff;
    // text-align: center;
    justify-content: center;
    align-items: center;
  }
}
.step-3B__summary {
  margin-top: 10px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.units {
  font-size: 12px;
  opacity: 0.6;
}
</style>
